export class DumbDashboardInfo {
    lettersOfIntroUsed: number;
    lettersOfIntroAllowed: number;
    newsSubmittedThisYear: number;
    pendingNewsSubmissions: number;
    adsSubmittedThisYear: number;
    pendingAds: number;
    pendingLettersOfIntroduction: number;
}
